(() => {
  const ROOT_SELECTOR = '#free-shipping-root';
  let isRefreshing = false;      // ← verrou anti-boucle
  let refreshTimer = null;
  let drawerObserver = null;     // ← on garde la réf pour (dé)brancher

  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));

  function replaceRootWith(html, sectionId) {
    const tpl = document.createElement('div');
    tpl.innerHTML = html;

    const next = tpl.querySelector(`${ROOT_SELECTOR}[data-section-id="${CSS.escape(sectionId)}"]`);
    if (!next) return;

    // ⛔️ stop l’observer pendant le swap pour éviter le loop
    if (drawerObserver) drawerObserver.disconnect();

    document
      .querySelectorAll(`${ROOT_SELECTOR}[data-section-id="${CSS.escape(sectionId)}"]`)
      .forEach((current) => current.replaceWith(next.cloneNode(true)));

    // ✅ relance l’observer
    attachDrawerObserver();
  }

  async function renderSections(sectionIds) {
    const ids = uniq(sectionIds);
    if (!ids.length) return null;

    const url = `${location.pathname}?sections=${ids.map(encodeURIComponent).join(',')}`;
    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(`Failed render ${res.status}`);
    return res.json();
  }

  async function refreshFreeShippingRoots() {
    if (isRefreshing) return;        // ← bloque si déjà en cours
    if (refreshTimer) return;        // ← debounce
    refreshTimer = setTimeout(async () => {
      refreshTimer = null;

      const roots = document.querySelectorAll(ROOT_SELECTOR);
      if (!roots.length) return;

      const sectionIds = uniq(Array.from(roots).map(r => r.getAttribute('data-section-id')));
      try {
        isRefreshing = true;         // ← verrou ON
        const payload = await renderSections(sectionIds);
        if (!payload) return;
        sectionIds.forEach((sid) => {
          const html = payload[sid];
          if (html) replaceRootWith(html, sid);
        });
      } catch (e) {
        console.warn('[FreeShipping] refresh failed:', e);
      } finally {
        // petit délai pour laisser les scripts du thème re-binder leurs listeners
        setTimeout(() => { isRefreshing = false; }, 50); // ← verrou OFF
      }
    }, 120); // debounce léger
  }

  // --- Events (identiques à avant) : appelez TOUJOURS queueRefresh() plutôt que setTimeout
  let queueTimer;
  function queueRefresh() {
    if (isRefreshing) return;        // ← respecte le verrou
    clearTimeout(queueTimer);
    queueTimer = setTimeout(refreshFreeShippingRoots, 180);
  }

  [
    'cart:updated','cart:change','cart:refresh',
    'lineItem:updated','sleek:cart:updated','sleek:cart:change','ajaxProduct:added'
  ].forEach(evt => document.addEventListener(evt, queueRefresh, { passive: true }));

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form instanceof HTMLFormElement && (form.getAttribute('action') || '').includes('/cart/add')) {
      queueRefresh();
    }
  }, true);

  const CLICK_SELECTORS = [
    '[data-quantity-plus]','[data-quantity-minus]','.quantity__button','.qty__button','.qty__adjust',
    '[data-cart-remove]','.cart-item__remove','.minicart__remove','button[name="remove"]',
    '[data-cart-drawer] [data-update-quantity]','[data-cart-drawer] [data-remove]'
  ].join(',');

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t instanceof Element && t.closest(CLICK_SELECTORS)) queueRefresh();
  }, true);

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t instanceof Element && t.matches('input[name="updates[]"], .quantity__input, [data-quantity-input]')) {
      queueRefresh();
    }
  }, true);

  // Interception fetch/xhr (inchangé sauf qu’on appelle queueRefresh)
  (function patchFetchOnce() {
    if (window.__freeShippingFetchPatched) return;
    window.__freeShippingFetchPatched = true;

    const origFetch = window.fetch;
    window.fetch = async function patchedFetch(input, init) {
      let url = '';
      try { url = typeof input === 'string' ? input : input.url; } catch(_) {}
      const isCartCall = url && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url);
      const res = await origFetch.apply(this, arguments);
      if (isCartCall) setTimeout(queueRefresh, 60);
      return res;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this.__isCartCall = url && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(String(url));
      return origOpen.apply(this, arguments);
    };
    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      this.addEventListener('load', () => { if (this.__isCartCall) setTimeout(queueRefresh, 60); });
      return origSend.apply(this, arguments);
    };
  })();

  // --- MutationObserver (optionnel) ----------------------------------------
  function attachDrawerObserver() {
    const drawerEl = document.querySelector('[data-cart-drawer], #CartDrawer, .mini-cart, .minicart');
    if (!drawerEl) return;
    // Si tu préfères, commente complètement ce bloc pour supprimer l’observer.
    try {
      if (drawerObserver) drawerObserver.disconnect();
      drawerObserver = new MutationObserver(() => {
        if (!isRefreshing) queueRefresh(); // ← respecte le verrou
      });
      // On limite la zone observée et évite d’écouter les attributs
      drawerObserver.observe(drawerEl, { childList: true, subtree: true });
    } catch(_) {}
  }

  document.addEventListener('DOMContentLoaded', () => {
    attachDrawerObserver();
    queueRefresh();
  });
})();
